<template>
<div>
<div class="container-fluid">
            <div class="page-title">
              <div class="row">
                <div class="col-6">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item active"><b v-html="title"></b></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
</div>
</template>

<script>

  export default {
    components: {},
    methods: {
      shareToWeb: function () {
        this.$emit('shareToWeb')
      },
      exportAsPdf: function () {
        this.$emit('exportAsPdf')
      },
    },

    props: {
      title: {
        default: 'home'
      },
      showPath: {
        default: false
      },
      showDownload: {
        default: false
      },
      main: {
        default: ''
      }
    }
  };
</script>
